import React, { FC, useCallback, useContext, useEffect, useState } from "react";
import { D1_PHQs, D25_PHQs, D3_PHQs, D4_PHQs, D69_PHQs, D7_PHQs, D8_PHQs } from "../../../constants/PHQ";
import { useAnalysisFlow } from "../../../contexts";
import { FaHandPointRight } from "react-icons/fa";
import ThemeRadioButton from "../../../components/radioButton/ThemeRadioButton";
import { Button } from "@mui/base";
import "./style.scss";
import { MdKeyboardDoubleArrowLeft, MdKeyboardDoubleArrowRight } from "react-icons/md";

const PHQCore: FC<any> = ({ foot }: { foot: string }) => {
	const { footcareAnalysis, setFootcareAnalysis, setCurrentIdx, handleNextClick, handlePrevClick } =
		useAnalysisFlow();
	console.log(footcareAnalysis);

	const [corePHQs, setCorePHQs] = useState<any[]>([]);

	const handlePHQChange = (event: React.ChangeEvent<HTMLInputElement>, success: boolean) => {
		const { name } = event.target;
		setFootcareAnalysis((prev: any) => ({
			...prev,
			[foot]: prev[foot].map((item: any) => {
				const key = Object.keys(item)[0];
				return key === name ? { [key]: success } : item;
			})
		}));
	};

	const generateCorePHQs = () => {
		const painPointsList =
			foot === "LEFT" ? footcareAnalysis.left_pain_points_list : footcareAnalysis.right_pain_points_list;
		const PHQs = [
			{ points: [1], data: D1_PHQs },
			{ points: [2, 5], data: D25_PHQs },
			{ points: [3], data: D3_PHQs },
			{ points: [4], data: D4_PHQs },
			{ points: [6, 5], data: D69_PHQs },
			{ points: [7], data: D7_PHQs },
			{ points: [8], data: D8_PHQs }
		].filter(({ points }) => {
			// console.log(points);
			return points.some((point) => painPointsList.includes(point));
		});
		const questions = PHQs.map(({ data }) => data).reduce((acc, curr) => {
			return acc.concat(curr);
		}, []);
		console.log(questions);
		setCorePHQs(questions);
	};

	useEffect(() => {
		generateCorePHQs();
	}, []);

	return (
		<div className="relative w-full h-full">
			<div className="sub-header text-center bg-secondary text-white">
				Please Answer The Questions For Your {foot} foot.
			</div>
			<div className="pb-20 overflow-y-auto h-[90%] ml-5">
				{corePHQs.length > 0 &&
					corePHQs.map((corePHQ, idx) => {
						const analysisItem = footcareAnalysis[foot].find(
							(item: any) => corePHQ.name == Object.keys(item)[0]
						);
						const analysisValue = analysisItem ? Object.values(analysisItem)[0] : null;

						return (
							<div key={idx} className="mb-6">
								<div className="text-xl font-bold flex flex-row items-center px-2 py-3 bg-blue-gray-50 rounded-md">
									<FaHandPointRight className="question-icon" />
									<span className="text-2xl">&nbsp;&nbsp;&nbsp;{corePHQ.label}</span>
								</div>
								<div className="flex flex-row mt-2">
									<ThemeRadioButton
										checked={analysisValue === true}
										success
										handleChange={handlePHQChange}
										label="Yes"
										name={corePHQ.name}
									/>
									<ThemeRadioButton
										checked={analysisValue === false}
										success={false}
										handleChange={handlePHQChange}
										label="No"
										name={corePHQ.name}
									/>
								</div>
							</div>
						);
					})}
			</div>
			<div className="bottom-pointer-left" onClick={handlePrevClick}>
				<MdKeyboardDoubleArrowLeft className="hover:scale-90 text-3xl" />
				<span className="text-[1.5vw] font-bold ml-3">Back</span>
			</div>
			<div className="bottom-pointer-right" onClick={handleNextClick}>
				<span className="text-[1.5vw] font-bold">Next</span>
				<MdKeyboardDoubleArrowRight className="hover:scale-90 text-3xl ml-3" />
			</div>
		</div>
	);
};

export default PHQCore;
